// reducers/listReducer.js
import { FETCH_DERNIER_DOCS_SUCCESS, FETCH_DERNIER_DOCS_FAILURE,REDIRECT_TO_LOGIN } from './actionsTypes';

const initialState = {
  derniersDocsData: [],
  error: null,
  redirectToLoginPage: false,
};

const DerniersDocsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DERNIER_DOCS_SUCCESS:
      return {
        ...state,
        derniersDocsData: action.payload.derniersDocsData,
        error: null,
      };
    case FETCH_DERNIER_DOCS_FAILURE:
      return {
        ...state,
        derniersDocsData: [],
        error: action.payload.error,
      };
    case REDIRECT_TO_LOGIN:
        return {
            ...state,
            redirectToLoginPage: true,
        };
    default:
      return state;
  }
};

export default DerniersDocsReducer;
